import { ViewSearchNothingIcon } from '@/client/assets';
import { useTranslation } from 'react-i18next';

export const SearchNothing = ({ text }: { text: string }) => {
  const { t } = useTranslation();
  return (
    <div className="w-full p-4 space-y-3 text-center">
      <ViewSearchNothingIcon className="size-16.5 mx-auto fill-foreground/10" />
      <span className="text-foreground/70 font-normal text-sm text-center">{t('no-results-for-text', { text })}</span>
    </div>
  );
};
